module.exports = __webpack_public_path__ + "static/img/Ripple-1s-32px.14dd3d3c.svg";